import React from 'react';
import classNames from '../../utils/classNames';

interface BetaBadgeProps {
    className?: string;
}

function BetaBadge({ className = '' }: BetaBadgeProps) {
    return (
        <span
            className={classNames(
                'border-menu-color text-menu-color inline-block select-none rounded',
                "border border-solid px-1 py-0.5 text-xs uppercase after:content-['beta']",
                className
            )}
        />
    );
}

export default BetaBadge;
